import React from "react";
import "../KYCVerification.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiCheckCircle,
    FiShield,
    FiUserCheck,
    FiFileText,
    FiCamera,
    FiDatabase,
    FiGlobe,
    FiLock,
    FiZap,
    FiTrendingUp
} from "react-icons/fi";


const KYCVerification = () => {

    return (

        <>

            <Header />


            <div className="kyc-page">


                {/*=====================================================
                            HERO SECTION
                ======================================================*/}


                <section className="kyc-hero">


                    <div className="container">


                        <div className="kyc-hero-content">


                            <span className="kyc-tag">

                                KYC VERIFICATION SERVICES

                            </span>



                            <h1>

                                Secure Digital Identity
                                <span> Verification Solutions</span>

                            </h1>



                            <p>

                                Saivari Fintech provides intelligent KYC verification
                                solutions that help banks, NBFCs, payment providers,
                                insurance companies, and fintech businesses onboard
                                customers securely while meeting regulatory compliance
                                requirements.

                            </p>



                            <div className="kyc-buttons">


                                <a
                                    href="/contact"
                                    className="kyc-primary-btn"
                                >
                                    Get Consultation
                                </a>



                                {/* <Link
                                    to="/services"
                                    className="kyc-secondary-btn"
                                >
                                    Explore Services
                                </Link> */}


                            </div>


                        </div>


                    </div>


                </section>





                {/*=====================================================
                            BREADCRUMB
                ======================================================*/}


                <section className="kyc-breadcrumb">


                    <div className="container">


                        <Link to="/">
                            Home
                        </Link>


                        <FiChevronRight />


                        <Link to="/services">
                            Solutions
                        </Link>


                        <FiChevronRight />


                        <span>
                            KYC Verification
                        </span>


                    </div>


                </section>







                {/*=====================================================
                            OVERVIEW
                ======================================================*/}



                <section className="kyc-overview">


                    <div className="container kyc-grid">


                        <div className="kyc-content">


                            <span className="section-tag">
                                KYC SOLUTIONS
                            </span>



                            <h2>

                                Simplifying Customer
                                <span> Identity Verification</span>

                            </h2>



                            <p>

                                Modern financial services require fast, secure, and
                                accurate identity verification. Our KYC solutions
                                enable organizations to verify customers digitally
                                while reducing fraud risks and improving onboarding
                                experiences.

                            </p>



                            <p>

                                We combine automation, secure verification workflows,
                                API integrations, and compliance expertise to help
                                businesses establish trusted digital identities.

                            </p>




                            <div className="kyc-checks">


                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Digital Customer Onboarding
                                    </span>

                                </div>



                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Identity Verification Automation
                                    </span>

                                </div>



                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Regulatory Compliance Support
                                    </span>

                                </div>



                                <div>

                                    <FiCheckCircle />

                                    <span>
                                        Fraud Prevention & Risk Reduction
                                    </span>

                                </div>


                            </div>



                        </div>







                        <div className="kyc-dashboard">


                            <div className="kyc-card">

                                <FiUserCheck />

                                <h3>
                                    Identity Check
                                </h3>

                                <span>
                                    Verified Customers
                                </span>

                            </div>



                            <div className="kyc-card">

                                <FiFileText />

                                <h3>
                                    Document KYC
                                </h3>

                                <span>
                                    Secure Validation
                                </span>

                            </div>



                            <div className="kyc-card">

                                <FiCamera />

                                <h3>
                                    Face Verification
                                </h3>

                                <span>
                                    Biometric Security
                                </span>

                            </div>




                            <div className="kyc-card">

                                <FiDatabase />

                                <h3>
                                    Data Security
                                </h3>

                                <span>
                                    Protected Records
                                </span>

                            </div>



                        </div>



                    </div>


                </section>








                {/*=====================================================
                            CAPABILITIES
                ======================================================*/}



                <section className="kyc-capabilities">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                KYC CAPABILITIES
                            </span>



                            <h2>

                                Complete Digital Identity
                                <span> Verification Platform</span>

                            </h2>



                            <p>

                                Our solutions help organizations verify customers
                                efficiently while maintaining security, accuracy,
                                and regulatory compliance.

                            </p>


                        </div>






                        <div className="kyc-service-grid">



                            <div className="kyc-service-card">

                                <div className="kyc-icon">
                                    🪪
                                </div>

                                <h3>
                                    Document Verification
                                </h3>

                                <p>
                                    Automated verification of identity documents
                                    with secure validation processes.
                                </p>

                            </div>





                            <div className="kyc-service-card">

                                <div className="kyc-icon">
                                    🤳
                                </div>

                                <h3>
                                    Biometric Verification
                                </h3>

                                <p>
                                    Face authentication and biometric checks for
                                    secure customer identification.
                                </p>

                            </div>





                            <div className="kyc-service-card">

                                <div className="kyc-icon">
                                    🔍
                                </div>

                                <h3>
                                    Identity Screening
                                </h3>

                                <p>
                                    Customer screening workflows to identify risks
                                    and prevent fraudulent activities.
                                </p>

                            </div>





                            <div className="kyc-service-card">

                                <div className="kyc-icon">
                                    🔗
                                </div>

                                <h3>
                                    API Integration
                                </h3>

                                <p>
                                    Seamless integration with banking platforms,
                                    fintech systems, and digital applications.
                                </p>

                            </div>





                            <div className="kyc-service-card">

                                <div className="kyc-icon">
                                    🛡
                                </div>

                                <h3>
                                    Fraud Prevention
                                </h3>

                                <p>
                                    Advanced verification methods to reduce identity
                                    fraud and operational risks.
                                </p>

                            </div>





                            <div className="kyc-service-card">

                                <div className="kyc-icon">
                                    ⚡
                                </div>

                                <h3>
                                    Fast Onboarding
                                </h3>

                                <p>
                                    Improve customer experience with faster digital
                                    onboarding journeys.
                                </p>

                            </div>


                        </div>


                    </div>


                </section>







                {/*=====================================================
                            CHALLENGES
                ======================================================*/}



                <section className="kyc-challenges">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                CHALLENGES WE SOLVE
                            </span>



                            <h2>

                                Making Identity Verification
                                <span> Simple & Secure</span>

                            </h2>


                        </div>






                        <div className="challenge-grid">



                            <div>

                                <FiShield />

                                <h3>
                                    Fraud Risks
                                </h3>

                                <p>
                                    Reduce fake identities and unauthorized access
                                    through secure verification.
                                </p>

                            </div>




                            <div>

                                <FiLock />

                                <h3>
                                    Data Security
                                </h3>

                                <p>
                                    Protect sensitive customer information with
                                    secure verification practices.
                                </p>

                            </div>




                            <div>

                                <FiTrendingUp />

                                <h3>
                                    Slow Onboarding
                                </h3>

                                <p>
                                    Accelerate customer onboarding with automated
                                    KYC workflows.
                                </p>

                            </div>


                        </div>


                    </div>


                </section>












                <section className="kyc-process">


                    <div className="container">


                        <div className="section-heading">

                            <span className="section-tag">
                                KYC PROCESS
                            </span>


                            <h2>

                                Our Digital Verification
                                <span> Workflow</span>

                            </h2>

                        </div>





                        <div className="kyc-process-grid">



                            <div className="kyc-process-card">

                                <div className="process-number">
                                    01
                                </div>

                                <h3>
                                    Customer Data Collection
                                </h3>

                                <p>
                                    Collect customer information through secure
                                    digital onboarding channels.
                                </p>

                            </div>




                            <div className="kyc-process-card">

                                <div className="process-number">
                                    02
                                </div>

                                <h3>
                                    Document Verification
                                </h3>

                                <p>
                                    Validate submitted identity documents using
                                    secure verification workflows.
                                </p>

                            </div>




                            <div className="kyc-process-card">

                                <div className="process-number">
                                    03
                                </div>

                                <h3>
                                    Identity Approval
                                </h3>

                                <p>
                                    Complete verification checks and approve
                                    verified customer profiles.
                                </p>

                            </div>


                        </div>


                    </div>


                </section>





                <section className="kyc-benefits">


                    <div className="container">


                        <div className="section-heading">


                            <span className="section-tag">
                                BUSINESS BENEFITS
                            </span>


                            <h2>

                                Why Choose Our
                                <span> KYC Solutions</span>

                            </h2>


                        </div>





                        <div className="benefit-grid">



                            <div>

                                <FiZap />

                                <h3>
                                    Faster Onboarding
                                </h3>

                                <p>
                                    Improve customer experience with quick
                                    verification.
                                </p>

                            </div>




                            <div>

                                <FiShield />

                                <h3>
                                    Better Security
                                </h3>

                                <p>
                                    Strengthen identity protection and reduce fraud.
                                </p>

                            </div>




                            <div>

                                <FiGlobe />

                                <h3>
                                    Scalable Platform
                                </h3>

                                <p>
                                    Support growing customer verification needs.
                                </p>

                            </div>




                            <div>

                                <FiLock />

                                <h3>
                                    Compliance Ready
                                </h3>

                                <p>
                                    Maintain secure regulatory processes.
                                </p>

                            </div>



                        </div>


                    </div>


                </section>




            </div>



            <Footer />


        </>

    );

};


export default KYCVerification;